export function getDeviceGraphic(lookIn, lookFor, typename) {
	let deviceName = typename.replace(/ /g, '-')
	deviceName = lookIn.$t(`devices.${deviceName}.${lookFor}`)

	try {
		return require('@graphics/devices/' + deviceName)
	} catch (err) {
		console.warn('getDeviceGraphic', err)
		return ''
	}
}

export function getCycleIcon (typename) {
	var cycleUrl = ''

	if (typename.indexOf('WS') === typename.length - 2) { // removed check in description for 'weather' - only WS appears in typename	-jimm 07.aug.2018
		cycleUrl = require('@graphics/CycleManagerWeatherStation.png')
	} else {
		cycleUrl = require('@graphics/CycleManagerJavaWebStart.png')
	}
	return cycleUrl
}


export function getConnectionIcon(Code) {
	const conversionTable =
	[
		{
			code: 'E00/E01',
			message: 'Connection failure',
			action: 'end',
			icon: 'connection-failed'
		},
		{
			code: 'E02',
			message: 'Server timeout',
			action: 'end',
			icon: 'connection-failed'
		},
		{
			code: 'E03',
			message: 'Controller disconnected',
			action: 'end',
			icon: 'connection-no-connection'
		},
		{
			code: 'I00',
			message: 'Connecting',
			icon: 'connection-connecting'
		},
		{
			code: 'I01',
			message: 'Connected',
			icon: 'connection-connected'
		},
		{
			code: 'I01:01',
			message: 'Synced',
			action: 'end',
			icon: 'connection-connected-in-sync'
		},
		{
			code: 'E01:110',
			message: 'Connection Issues<br>Re-Attempting',
			action: 'end',
			icon: 'connection-connecting'
		},
		{
			code: 'I01:02',
			message: 'Not Synced',
			action: 'end',
			icon: 'connection-connected-not-in-sync'
		},
		{
			code: 'I02',
			message: 'Controller Disconnected',
			action: 'end',
			icon: 'connection-failed'
		},
		{
			code: 'I0E/I0F',
			message: 'Connection established',
			icon: 'connection-connected'
		}
	]

	return conversionTable.filter(item => item.code === Code)[0]
}

export default {
	getCycleIcon,
	getConnectionIcon
}
